/*
 *   File : 404.js
 *   Author : https://evoqins.com
 *   Description : Page not found file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

const PageNotFound = () => {
    return (
        <section className='e-section-height py-4 px-5 text-center d-flex flex-column align-items-center justify-content-center'>
            <img src={require("../../Assets/Image/404.png")}
                draggable={false}
                height={334}
                width={338}
                className='e-404-img'
                alt='404' />
        </section>
    )
}

export default PageNotFound;
